module.exports = __webpack_public_path__ + "img/icon-vr.6002acdc.svg";